import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { UiService } from './ui.service';
import { LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class ApiErrorService {
  public flag = false;
  public hasError = new BehaviorSubject<boolean>(false);
  public errorStatus = new BehaviorSubject<any>(null);
  private exceptionalRoutes: string[] = ['/flights', '/my-flights'];
  constructor(
    private router: Router,
    private loadingController: LoadingController
  ) {}
  public get value(): Observable<boolean> {
    return this.hasError.asObservable();
  }
  public get errorStatusValue(): Observable<any> {
    return this.errorStatus.asObservable();
  }
  public updateValue(newVal): void {
    this.flag = this.exceptionalRoutes.includes(this.router.url);
    if (!this.flag) {
      if (newVal) {
        const dismissAllLoaders = async () => {
          let top = await this.loadingController.getTop();
          while (top) {
            await top.dismiss();
            top = await this.loadingController.getTop();
          }
        };
        dismissAllLoaders();
      }
      this.hasError.next(newVal);
    } else {
      this.hasError.next(false);
      this.flag = false;
    }
  }

  public getErrorStatus(): any {
    return this.errorStatus.getValue();
  }

  public setErrorStatus(value: any) {
    return this.errorStatus.next(value);
  }
}
